import _ from "lodash";

export const computeCustomGradingPeriodsDiff = ({
  entities,
  currentEntities,
  valueKey,
}) => {
  const processedEntities = _.map(entities, (entity, index) => ({
    ...entity,
    [valueKey]: _.trim(_.get(entity, valueKey, "")),
    displaySequence: index + 1,
  }));

  const lookupMap = _.keyBy(processedEntities, "id");
  const originalLookupMap = _.keyBy(currentEntities, "id");

  const entityIds = _.map(processedEntities, "id");
  const originalIds = _.map(currentEntities, "id");

  const addedIds = _.difference(entityIds, originalIds);
  const removedIds = _.difference(originalIds, entityIds);
  const potentiallyUpdatedIds = _.difference(entityIds, addedIds);

  const updatedIds = _.filter(potentiallyUpdatedIds, id => {
    const currentEntity = lookupMap[id];
    const originalEntity = originalLookupMap[id];

    return (
      _.get(currentEntity, valueKey, "") !==
        _.get(originalEntity, valueKey, "") ||
      _.get(currentEntity, "displaySequence") !==
        _.get(originalEntity, "displaySequence")
    );
  });

  const added = _.map(addedIds, id => {
    const entity = lookupMap[id];

    return {
      [valueKey]: _.get(entity, valueKey, ""),
      displaySequence: _.get(entity, "displaySequence"),
    };
  });

  const updated = _.map(updatedIds, id => {
    const entity = lookupMap[id];

    return {
      id: entity.id,
      [valueKey]: _.get(entity, valueKey, ""),
      displaySequence: _.get(entity, "displaySequence"),
    };
  });

  const removed = _.map(removedIds, id => ({ id }));

  return {
    added,
    updated,
    removed,
    hasChanges: !_.isEmpty(added) || !_.isEmpty(updated) || !_.isEmpty(removed),
  };
};
